import React from 'react';
import { MapPinIcon, MailIcon, LinkedinIcon, ArrowUpRightIcon, DownloadIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
const section = sections[9];
const enquiries = [{
  title: 'Board Appointments',
  detail: 'Chair, Senior Independent Director and Non-Executive Director mandates. Please include the ownership structure, committee expectations and time commitment.',
  subject: 'Board Appointment Enquiry'
}, {
  title: 'Advisory Enquiries',
  detail: 'Industrial strategy, governance review, committee effectiveness and transition support for boards facing a change of ownership or leadership.',
  subject: 'Advisory Enquiry'
}, {
  title: 'Speaking Engagements',
  detail: 'Advanced manufacturing, industrial decarbonisation, sovereign defence capability, public–private partnership and the future STEM workforce.',
  subject: 'Speaking Engagement Enquiry'
}];
export function Contact() {
  return <div data-id="element-137" data-mp="15f6rw6y8z7wi">
      <PageHeader section={section} intro="Direct routes of enquiry. All correspondence is read personally and treated in confidence." data-id="element-138" data-mp="15dcd7adkkc0v" />

      <div className="mt-12 grid gap-px border border-slate-200 bg-slate-200 lg:grid-cols-3" data-id="element-139" data-mp="1e91w9crjoub3">
        {enquiries.map(item => <article key={item.title} className="flex h-full flex-col bg-white p-8" data-id="element-140" data-mp="1j8xzvawbyjq4">
            <h2 className="font-serif text-xl leading-snug text-navy" data-id="element-141" data-mp="mi5m4jwvd3ri">
              {item.title}
            </h2>
            <p className="mt-4 text-[13px] leading-relaxed text-slateink" data-id="element-142" data-mp="qk8xz9ngaadb">
              {item.detail}
            </p>
            <a href={`mailto:janice.m.munday@gmail.com?subject=${encodeURIComponent(item.subject)}`} className="mt-auto inline-flex items-center gap-2 pt-7 text-[13px] font-semibold text-gold-dark transition-colors duration-150 ease-out hover:text-navy" data-id="element-143" data-mp="10gcb1ajubtf1">
              Open this enquiry
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="1m5shjpc9lyik" />
            </a>
          </article>)}
      </div>

      <section className="relative mt-14 overflow-hidden bg-navy pattern-grid p-9 lg:p-12" data-id="element-145" data-mp="1hamugn74mdsw">
        <div className="relative grid gap-12 lg:grid-cols-2" data-id="element-146" data-mp="1w36xzoy6unav">
          <div data-id="element-147" data-mp="1r7rk4x06kreg">
            <div className="flex items-center gap-3" data-id="element-148" data-mp="1r781tf6mc0zw">
              <span className="h-px w-8 bg-gold" aria-hidden="true" data-id="element-149" data-mp="13gcbynlq3fva" />
              <span className="text-[11px] font-semibold uppercase tracking-overline text-gold" data-id="element-150" data-mp="yhsrysqowe5k">
                Contact details
              </span>
            </div>
            <h2 className="mt-5 font-serif text-2xl leading-tight text-white sm:text-3xl" data-id="element-151" data-mp="1d88hgjq5289j">
              Correspondence direct to the boardroom.
            </h2>

            <dl className="mt-9 space-y-5" data-id="element-152" data-mp="kpkypaym75bm">
              <div className="flex items-start gap-4" data-id="element-153" data-mp="kojiyt6nlunk">
                <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-154" data-mp="fs2ws4j0lqd4" />
                <div data-id="element-155" data-mp="2rcjxqnuvgp8z">
                  <dt className="sr-only" data-id="element-156" data-mp="2w5d39dy601m4">Location</dt>
                  <dd className="text-[15px] text-slate-200" data-id="element-157" data-mp="2w6xy74oe5mki">
                    London, United Kingdom
                  </dd>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-158" data-mp="2mes860hp9f7y">
                <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-159" data-mp="2mdh0hpl4vnbk" />
                <div data-id="element-160" data-mp="3f4hbwllsntd9">
                  <dt className="sr-only" data-id="element-161" data-mp="3f2wcahkmhk8j">Email</dt>
                  <dd data-id="element-162" data-mp="314q08rir2p2f">
                    <a href="mailto:janice.m.munday@gmail.com" className="text-[15px] text-slate-200 underline decoration-gold/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold" data-id="element-163" data-mp="3157sld2akj52">
                      janice.m.munday@gmail.com
                    </a>
                  </dd>
                </div>
              </div>
            </dl>
          </div>

          <div className="flex flex-col justify-center gap-3 border-t border-white/10 pt-10 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-164" data-mp="29zbzs6bxilgs">
            <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-gold px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-150 ease-out hover:bg-gold-dark" data-id="element-165" data-mp="207y469n3m5sx">
              <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-166" data-mp="2nz3igkde4q14" />
              LinkedIn Profile
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-167" data-mp="2ixe4owys9y9c" />
            </a>
            <a href="mailto:janice.m.munday@gmail.com?subject=Executive%20CV%20Request" className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-white/25 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-168" data-mp="2ew2futnqhh27">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-169" data-mp="3f3hadar7h6rm" />
              Request Executive CV
            </a>
            <p className="mt-3 text-[12px] leading-relaxed text-slate-500" data-id="element-170" data-mp="3o68m7bnzu4js">
              Responses are typically issued within five working days.
            </p>
          </div>
        </div>
      </section>
    </div>;
}